<!--
 * @Description:  上传图片--组件
 * @Author: Mankeung
 * @Date: 2021-07-19 10:37:08
 * @LastEditors: Mankeung
 * @LastEditTime: 2021-07-30 11:22:11
-->
<template>
  <section>
    <!--图片部分-->
    <div class="screenshot">
      <span v-for="(imgUrl, index) in srcList" :key="index" class="slideshow">
        <div class="icon-close" @click="removeUploading(index)" v-if="isMoer">
          <i class="el-icon-close"></i>
        </div>
        <el-image
          style="width: 65px; height: 65px; border-radius: 6px"
          :src="imgUrl"
          fit="cover"
          @click="getPolicy"
        >
          <div slot="error" class="up-btn" @click="getPolicy" v-loading="loading1"  style="width: 62px; height: 62px; line-height: 67px">
              <p style="font-size:12px;">加载失败</p>
          </div>
        </el-image>
      </span>
      <div
        v-loading="loading1"
        class="up-btn"
        style="width: 65px; height: 65px; line-height: 70px"
        @click="getPolicy"
        v-if="isMoer"
      >
        <i class="el-icon-plus"></i>
      </div>
    </div>
    <input type="file" ref="file" @change="getFile" />
  </section>
</template>

<script>
import { ossUpload } from "@utils/filters/upload";

export default {
  props: ["keyWord", "params"],
  data() {
    return {
      loading1: false, //加载中
      srcList: [], //上传图片数组
      isMoer: true,

      getKeyWord: this.keyWord, //接收动态keyWord的值
      myParams: this.params, //接收动态params的值
    };
  },
  created() {
    this.wake(); //初始化--回显图片
  },
  mounted() {
    // this.wake();//初始化--回显图片
  },
  watch: {
    myParams() {
    },
  },
  methods: {
    wake() {
      this.srcList = [];
      if (
        this.myParams[this.getKeyWord] &&
        this.myParams[this.getKeyWord] != ""
      ) {
        this.srcList[0] = this.myParams[this.getKeyWord];
        this.isMoer = false;
      } else {
        this.isMoer = true;
      }
    },

    /**
     * 阿里云OSS签名
     */
    getPolicy() {
      // this.$parent.$parent.$parent.$parent.$parent.$parent.dialogVisible
      this.$refs.file.dispatchEvent(new MouseEvent("click"));
    },
    async getFile() {
      this.loading1 = true;
      const that = this;
      const { data: resData } = await this.$get("aliyun/oss/sign", {});
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
        that.$refs.file.files[0],
        resData.data,
        "one" //'more','one'
      );
      this.isMoer = false;
      this.loading1 = false;
      this.srcList = addRoutes;
      this.myParams[this.getKeyWord] = this.srcList[0]; //赋值相应的字段
    },
  },
};
</script>

<style>
</style>

